import { render } from "./CreateWallet.vue?vue&type=template&id=777d4376"
import script from "./CreateWallet.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateWallet.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/dashboard/CreateWallet.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "777d4376"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('777d4376', __exports__)) {
    api.reload('777d4376', __exports__)
  }
  
  module.hot.accept("./CreateWallet.vue?vue&type=template&id=777d4376", () => {
    api.rerender('777d4376', render)
  })

}


export default __exports__